import { GenericUnits } from "@/libs/units/generic";
import { LengthUnits } from "@/libs/units/length";
import { PercentageUnits } from "@/libs/units/percentage";
import { PowerUnits } from "@/libs/units/power";
import type { RenderScenarioExportCols } from "./sizingExportTypes";

export const renderMotorCols: RenderScenarioExportCols = ({
  scenario,
  calcs,
  targetUnits
}) => [
  {
    section: "MOTOR",
    label: "Motor OD",
    targetUnit: LengthUnits.Inches,
    value: scenario.equipment.value?.r_motor?.outer_diameter_inches,
    disableConversion: true
  },
  {
    section: "MOTOR",
    label: "Motor Length",
    targetUnit: targetUnits.largeLengthUnit,
    value: calcs.equipmentLengths.motorLengthFt
  },
  {
    section: "MOTOR",
    label: "Motor Weight",
    targetUnit: targetUnits.massUnit,
    value: calcs.equipmentWeights.motorWeightLbs
  },
  {
    section: "MOTOR",
    label: "Rated HP",
    targetUnit: PowerUnits.HorsePower,
    value: scenario.equipment.value?.r_motor?.nameplate_horsepower
  },
  {
    section: "MOTOR",
    label: "Rated V",
    targetUnit: targetUnits.voltageUnit,
    value: scenario.equipment.value?.r_motor?.nameplate_voltage
  },
  {
    section: "MOTOR",
    label: "Rated A",
    targetUnit: targetUnits.currentUnit,
    value: scenario.equipment.value?.r_motor?.nameplate_current
  },
  {
    section: "MOTOR",
    label: "De rate Factor",
    targetUnit: PercentageUnits.Percentage,
    value: PercentageUnits.Ratio.toStandardUnit(
      scenario.parameters.value?.motor_rerate_ratio
    )
  },
  {
    section: "MOTOR",
    label: "Derated HP",
    targetUnit: PowerUnits.HorsePower,
    value: calcs.motorCalculations.adjustedReratedNameplateHP.value
  },
  {
    section: "MOTOR",
    label: "Derated V",
    targetUnit: targetUnits.voltageUnit,
    value: calcs.motorCalculations.adjustedReratedNameplateV.value
  },
  {
    section: "MOTOR",
    label: "Derated A",
    targetUnit: targetUnits.currentUnit,
    value: calcs.motorCalculations.adjustedReratedNameplateA.value
  },
  {
    section: "MOTOR",
    label: "Motor Operating Volts",
    targetUnit: targetUnits.voltageUnit,
    value: calcs.motorCalculations.motorVoltageV.value
  },
  {
    section: "MOTOR",
    label: "Motor Operating Current",
    targetUnit: targetUnits.currentUnit,
    value: calcs.motorCalculations.motorCurrentA.value
  },
  {
    section: "MOTOR",
    label: calcs.isScenarioEspShore.value
      ? "Motor Required HP @ Design Hz"
      : "Motor Required HP @ Duty Point",
    targetUnit: PowerUnits.HorsePower,
    value: calcs.motorCalculations.totalRequiredBrakeHP.value
  },
  {
    section: "MOTOR",
    label: "Motor Required HP @ 60Hz",
    targetUnit: PowerUnits.HorsePower,
    value: calcs.motorCalculations.totalRequired60HzBrakeHP.value.toFixed(0)
  },
  {
    section: "MOTOR",
    label: calcs.isScenarioEspShore.value
      ? "Motor Input HP"
      : "Motor Input HP @ Duty Point",
    targetUnit: PowerUnits.HorsePower,
    value: PowerUnits.Watts.toStandardUnit(
      calcs.motorCalculations.motorInputW.value
    )
  },
  {
    section: "MOTOR",
    label: "Motor Output HP",
    targetUnit: PowerUnits.HorsePower,
    value: PowerUnits.Watts.toStandardUnit(
      calcs.motorCalculations.motorOutputW.value
    )
  },
  {
    section: "MOTOR",
    label: "Motor Temperature Rating",
    targetUnit: targetUnits.tempUnit,
    value: scenario.equipment.value?.r_motor?.temperature_rating_fahrenheit
  },
  {
    section: "MOTOR",
    label: "Motor Internal Temperature",
    targetUnit: targetUnits.tempUnit,
    value: calcs.motorCalculations.motorInternalTemperatureF.value
  },
  {
    section: "MOTOR",
    label: "Motor Skin Temperature",
    targetUnit: targetUnits.tempUnit,
    value: calcs.motorCalculations.motorSkinTemperatureF.value
  },
  {
    section: "MOTOR",
    label: "Motor Load",
    targetUnit: PercentageUnits.Percentage,
    value: PercentageUnits.Ratio.toStandardUnit(
      calcs.motorCalculations.motorLoadRatio.value
    )
  },
  {
    section: "MOTOR",
    label: "Flow by motor",
    targetUnit: targetUnits.speedUnit,
    value: calcs.motorCalculations.flowVelocityAroundMotorFTSEC.value,
    hidden: !calcs.isScenarioEspShore.value
  },
  {
    section: "MOTOR",
    label: "Motor Operating RPM",
    targetUnit: GenericUnits.RevolutionsPerMinute,
    value: calcs.pumpCalculations.aggregate.operatingRPM.value
  },
  {
    section: "MOTOR",
    label: "Motor Efficiency",
    targetUnit: PercentageUnits.Percentage,
    value: PercentageUnits.Ratio.toStandardUnit(
      calcs.motorCalculations.motorEfficiencyRatio.value
    )
  },
  {
    section: "MOTOR",
    label: "Motor Power Factor",
    targetUnit: GenericUnits.Generic,
    value: calcs.motorCalculations.motorPowerFactor.value,
    decimalPlaceOverride: 3,
    hidden: !calcs.isScenarioEspShore.value
  },
  {
    section: "MOTOR",
    label: "Motor Shaft Rating",
    targetUnit: targetUnits.hydraulicPowerUnit,
    value: calcs.motorCalculations.motorShaftPowerLimitHP.value
  },
  {
    section: "MOTOR",
    label: "% Motor Shaft Load",
    targetUnit: PercentageUnits.Percentage,
    value: PercentageUnits.Ratio.toStandardUnit(
      calcs.motorCalculations.motorShaftRatingRatio.value
    )
  },
  {
    section: "MOTOR",
    label: "Motor Start up voltage",
    targetUnit: targetUnits.voltageUnit,
    value: calcs.surfaceDriveCalculations.startupVoltage.value
  },
  {
    section: "MOTOR",
    label: "Shroud ID",
    targetUnit: targetUnits.smallLengthUnit,
    value:
      LengthUnits.Inches.toStandardUnit(
        scenario.equipment.value?.r_shroud?.interior_diameter_inches
      ) || 0
  }
];
